import { Injectable } from '@angular/core';
import { AppConstants } from '../common/app.constants'
import { StorageService } from '../common/services/storage.service';


@Injectable({
    providedIn: 'root'
})
export class PermissionService {



    pagePermissionMaping: any[] = [
        { page: "department-edit", parent: "department" },
        { page: "shop-edit", parent: "shop" },
        { page: "area-edit", parent: "region" },
        { page: "kitchen-edit", parent: "kitchen" },
        { page: "uom-edit", parent: "uom" },
        { page: "reasons-edit", parent: "reason" },
        { page: "menu-edit", parent: "menu" },
        { page: "employee-category-edit", parent: "employee-category" },
        { page: "employee-edit", parent: "employee" },
        { page: "expense-edit", parent: "expense" },
        { page: "expense-type-edit", parent: "expense-type" },
        { page: "item-category-edit", parent: "item-category" },
        { page: "sale-item-edit", parent: "sale-item" },
        { page: "stock-category-edit", parent: "stock-category" },
        { page: "stocks-edit", parent: "stocks" },
        { page: "station-edit", parent: "station" },
        { page: "kitchen-edit", parent: "kitchen" },
        { page: "user-edit", parent: "user" },
        { page: "user-group-edit", parent: "usergroup" },
        { page: "voucher-edit", parent: "voucher" },
        { page: "customization-edit", parent: "customization" },
        { page: "payroll-group-edit", parent: "payroll-group" },
        { page: "shop-payroll-settings-edit", parent: "shop-payroll-settings" },
        { page: "combo-edit", parent: "combo" },
        { page: "auto-discount-edit", parent: "auto-discount" },
        { page: "discount-edit", parent: "discount" },
        { page: "item-class-display-order", parent: "display-order" },
        { page: "sale-item-display-order", parent: "display-order" },
        { page: "hot-item-display-order", parent: "display-order" },

    ];


    constructor(private storageService: StorageService) { }


    /**
     * Returns the page permission for currenmtly loged in user
     * @param page 
     * @returns 
     */
    getPagePermission(page: string): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const users = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        const permissionArr = users.permissions;
        const pagePermission = permissionArr.find((perm: any) => perm.page == page);
        // return (pagePermission) ? pagePermission.permission : this.getDefaultPermission(page);
        return {
            "can_view": 1,
            "can_add": 1,
            "can_edit": 1,
            "can_delete": 1,
            "can_execute": 1,
            "can_publish": 1,
            "can_export": 1,
            "can_import": 1,

        };
    }

    getRowPermission(pagePermission: any, rowId: any): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const user = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        let rowPermission = JSON.parse(JSON.stringify(pagePermission));
        if (user.user_type == 'SHOP' && rowId < AppConstants.MASTER_ID_MULTI_FACTOR) {
            rowPermission.can_edit = 0;
            rowPermission.can_delete = 0;
        }
        return rowPermission;
    }
    /**
     * Returns the list of permissions for the currently logged in user
     * @returns 
     */

    getPermission(): any {

        let sesUser = this.storageService.loadFromSession(AppConstants.SESSION_VAR_USER);
        const users = (sesUser !== null) ? JSON.parse(sesUser) : { id: 0 };
        const permissionArr = users.permissions;
        return permissionArr;
    }

    /**
     * The default permission is to view the content
     * @returns 
     */
    getDefaultPermission(page: string): any {
        var permission: any = {
            "can_view": 0,
            "can_add": 0,
            "can_edit": 0,
            "can_delete": 0,
            "can_execute": 0,
            "can_publish": 0,
            "can_export": 0,
            "can_import": 0,

        }

        const parentPage = this.pagePermissionMaping.find((pg: any) => pg.page == page);
        if (parentPage) {
            permission = this.getPagePermission(parentPage.parent);
        }
        return permission;
    }

    /**
     * Returns the permission set for the action
     * @param page 
     * @param action 
     * @returns 
     */
    hasPermission(page: string, action: string): boolean {

        const permission = this.getPagePermission(page);

        var hasPermission = 0;
        switch (action) {
            case 'view':
                hasPermission = permission.can_view;
                break;
            case 'add':
                hasPermission = permission.can_add;
                break;
            case 'edit':
                hasPermission = permission.can_edit;
                break;
            case 'delete':
                hasPermission = permission.can_delete;
                break;
            case 'execute':
                hasPermission = permission.can_execute;
                break;
            case 'publish':
                hasPermission = permission.can_publish;
                break;
            case 'export':
                hasPermission = permission.can_export;
                break;
        }
        // return (hasPermission == 1) ? true : false;
        return true;

    }

    /**
     * Modify permissions before setting to session storage
     */
    validatePermission(user: any): any {
        if (!user || user.user_type === 'HQ') {
            return user;
        }

        const allowed_list: any[] = [
            { page: 'user', can_add: 1, can_edit: 1, can_delete: 1 },
            { page: 'user-group', can_add: 1, can_edit: 1, can_delete: 1 },
            { page: 'employee-category', can_add: 1, can_edit: 1, can_delete: 1 },
            { page: 'employee', can_add: 1, can_edit: 1, can_delete: 1 },
            { page: 'sale-item', can_add: 0, can_edit: 1, can_delete: 1 }
        ];

        if (user.permissions && Array.isArray(user.permissions)) {
            user.permissions = user.permissions.map((permObj: any) => {
                if (permObj && permObj.page && permObj.permission) {
                    const allowedPage = allowed_list.find(p => p.page === permObj.page);
                    if (!allowedPage) {
                        permObj.permission.can_add = 0;
                        permObj.permission.can_edit = 0;
                        permObj.permission.can_delete = 0;
                    } else {
                        if (permObj.permission.can_add === 1 && allowedPage.can_add !== undefined) {
                            permObj.permission.can_add = allowedPage.can_add;
                        }
                        if (permObj.permission.can_edit === 1 && allowedPage.can_edit !== undefined) {
                            permObj.permission.can_edit = allowedPage.can_edit;
                        }
                        if (permObj.permission.can_delete === 1 && allowedPage.can_delete !== undefined) {
                            permObj.permission.can_delete = allowedPage.can_delete;
                        }
                    }
                }
                return permObj;
            });
        }
        return user;
    }

}
